<div nz-flex [nzVertical]="true">
  <nz-row nzGutter="24" class="rows displayFlex bgColor">
    <nz-col nzSpan="24">
      <!-- Header -->
      <nz-row class="p-t-12">
        <!-- Sorting -->
        <nz-col nzSpan="4" class="item-center">
          <div class="w-100">
            <nz-form-item>
              <nz-form-label [nzSpan]="10" class="text-bold">{{
                weeklyScheduleMX.sortBy
              }}</nz-form-label>
              <nz-form-control [nzSpan]="14">
                <nz-select [(ngModel)]="selectedOption" (ngModelChange)="onSortChange($event)">
                  <nz-option nzValue="craft" nzLabel="Craft"></nz-option>
                  <nz-option nzValue="job" nzLabel="Job"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-col>

        <nz-col nzSpan="8">
          <nz-row>
            <!-- Crew Details -->
            <nz-col nzSpan="8" class="item-center">
              <button nz-button [nzSize]="'small'" nzType="primary" class="h-100" (click)="openCrewDetails()">
                {{ weeklyScheduleMX.crewDetails }}
              </button>
            </nz-col>

            <!-- Week Selector -->
            <nz-col nzSpan="14" class="item-right pr-1 week-selector">
              <span class="font-size-15 text-bold">{{
                weeklyScheduleMX.workWeek
              }}</span>
              <div class="d-flex align-items-center bg-white">
                <nz-date-picker [nzDisabledDate]="disableNonMondays" (ngModelChange)="onDateChange($event)"
                [(ngModel)]="wwDate" nzFormat="MM-dd-yyyy"></nz-date-picker>
              </div>
            </nz-col>

            <!-- Refresh -->
            <nz-col nzSpan="2" class="item-left pl-1 h-auto">
              <button type="button" (click)="refresh()" class="cursor-pointer">
                <span class="brown-filter" nz-tooltip nzTooltipTitle="Refresh">!</span>
              </button>
            </nz-col>
          </nz-row>
          <!-- Filter Display -->
          <nz-row class="item-center">
            <h5 class="mt-3">{{ sFilterDisplay }}</h5>
          </nz-row>
        </nz-col>

        <!-- Filter -->
        <nz-col nzSpan="9" class="table-filter" id="filter">
          <table class="w-10">
            <tr>
              <td>
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('open')" class="green-filter"
                  [class.active]="selectedFilter == 'open'">
                  {{ weeklyScheduleMX.open }}
                </button>
              </td>
              <td>
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('os')" class="green-filter"
                  [class.active]="selectedFilter == 'os'">
                  {{ weeklyScheduleMX.os }}
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('done')" class="green-filter"
                  [class.active]="selectedFilter == 'done'">
                  {{ weeklyScheduleMX.done }}
                </button>
              </td>
              <td>
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('kit')" class="green-filter"
                  [class.active]="selectedFilter == 'kit'">
                  {{ weeklyScheduleMX.kit }}
                </button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <span class="fbd">{{ weeklyScheduleMX.fbdc }}</span>
              </td>
            </tr>
          </table>

          <table class="w-50">
            <tr>
              <td colspan="7">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('monthru')" class="blue-filter"
                  [class.active]="selectedFilter == 'monthru'">
                  {{ weeklyScheduleMX.monThru }}
                </button>
              </td>
              <td colspan="7">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('showall')" class="fw-bold"
                  [class.active]="selectedFilter == 'showall'">
                  {{ weeklyScheduleMX.showAll }}
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setDayFilter('mo')" class="blue-filter"
                  [class.active]="selectedFilter == 'mo'">
                  {{ weeklyScheduleMX.mo }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setDayFilter('tu')" class="blue-filter"
                  [class.active]="selectedFilter == 'tu'">
                  {{ weeklyScheduleMX.tu }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setDayFilter('we')" class="blue-filter"
                  [class.active]="selectedFilter == 'we'">
                  {{ weeklyScheduleMX.we }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setDayFilter('th')" class="blue-filter"
                  [class.active]="selectedFilter == 'th'">
                  {{ weeklyScheduleMX.th }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setDayFilter('fr')" class="blue-filter"
                  [class.active]="selectedFilter == 'fr'">
                  {{ weeklyScheduleMX.fr }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setDayFilter('sa')" class="blue-filter"
                  [class.active]="selectedFilter == 'sa'">
                  {{ weeklyScheduleMX.sa }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setDayFilter('su')" class="blue-filter"
                  [class.active]="selectedFilter == 'su'">
                  {{ weeklyScheduleMX.su }}
                </button>
              </td>
            </tr>

            <tr>
              @for (item of nextSevenDays; track item) {
                <td colspan="2">
                  <button nz-button [nzSize]="'small'" nzType="default" class="brown-filter non-clickable">
                    {{ item }}
                  </button>
                </td>
              }
            </tr>
          </table>

          <table class="w-10">
            <tr>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('pm')" class="blue-filter"
                  [class.active]="selectedFilter == 'pm'">
                  {{ weeklyScheduleMX.pm }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('i')" class="brown-filter"
                  [class.active]="selectedFilter == 'i'">
                  {{ weeklyScheduleMX.i }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('e')" class="brown-filter"
                  [class.active]="selectedFilter == 'e'">
                  {{ weeklyScheduleMX.e }}
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('sf')" class="blue-filter"
                  [class.active]="selectedFilter == 'sf'">
                  {{ weeklyScheduleMX.sf }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('m')" class="brown-filter"
                  [class.active]="selectedFilter == 'm'">
                  {{ weeklyScheduleMX.m }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('p')" class="brown-filter"
                  [class.active]="selectedFilter == 'p'">
                  {{ weeklyScheduleMX.p }}
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('bi')" class="blue-filter"
                  [class.active]="selectedFilter == 'bi'">
                  {{ weeklyScheduleMX.bi }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('c')" class="brown-filter"
                  [class.active]="selectedFilter == 'c'">
                  {{ weeklyScheduleMX.c }}
                </button>
              </td>
              <td colspan="2">
                <button nz-button [nzSize]="'small'" nzType="default" (click)="setFilter('oth')" class="brown-filter"
                  [class.active]="selectedFilter == 'oth'">
                  {{ weeklyScheduleMX.oth }}
                </button>
              </td>
            </tr>
          </table>
        </nz-col>

        <nz-col nzSpan="3" class="totalCount">
          <button class="exportbuttoncss" (click)="exportToExcel()" [disabled]="weeklySchedule.length === 0">
            @if (showExportLoader) {
              <i class="rotating-ring"></i>
            } @else {
              {{
              weeklyScheduleMX.exportToExcel
              }}
            }
          </button>
          <div class="text-align-center bgColorBeige">
            {{ totalSchedules }} {{ weeklyScheduleMX.records }}
          </div>
        </nz-col>
      </nz-row>

      <!-- Table View -->
      <nz-row class="bg-white">
        <table class="table-data responsive-table">
          <tr class="table-header">
            <th>
              <div class="table-title-align">
                {{ weeklyScheduleMX.taskPriority }}
                <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter1" nzTrigger="click" [nzClickHide]="false">
                  <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                </a>
                <nz-dropdown-menu #filter1="nzDropdownMenu" nzClickHide="false">
                  <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                    @for (item of priority; track item) {
                      <li nz-menu-item>
                        <label>
                          <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.priority)"
                            [checked]="item.selected" />
                            {{ item.name }}
                          </label>
                        </li>
                      }
                    </ul>
                  </nz-dropdown-menu>
                </div>

              </th>
              <th>
                <div class="table-title-align">
                  {{ weeklyScheduleMX.wonum }}
                  <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter2" nzTrigger="click" [nzClickHide]="false">
                    <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                  </a>
                  <nz-dropdown-menu #filter2="nzDropdownMenu" nzClickHide="false">
                    <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                      @for (item of wonum; track item) {
                        <li nz-menu-item>
                          <label>
                            <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.wonum)"
                              [checked]="item.selected" />
                              {{ item.name }}
                            </label>
                          </li>
                        }
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                </th>
                <th>
                  <div class="table-title-align">
                    {{ weeklyScheduleMX.taskType }}
                    <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter3" nzTrigger="click" [nzClickHide]="false">
                      <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                    </a>
                    <nz-dropdown-menu #filter3="nzDropdownMenu" nzClickHide="false">
                      <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                        @for (item of taskType; track item) {
                          <li nz-menu-item>
                            <label>
                              <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.taskType)"
                                [checked]="item.selected" />
                                {{ item.name }}
                              </label>
                            </li>
                          }
                        </ul>
                      </nz-dropdown-menu>
                    </div>
                  </th>
                  <th>{{ weeklyScheduleMX.sme }}</th>
                  <th>
                    <div class="table-title-align">
                      {{ weeklyScheduleMX.taskStatus }}
                      <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter4" nzTrigger="click" [nzClickHide]="false">
                        <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                      </a>
                      <nz-dropdown-menu #filter4="nzDropdownMenu" nzClickHide="false">
                        <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                          @for (item of taskStatus; track item) {
                            <li nz-menu-item>
                              <label>
                                <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.taskStatus)"
                                  [checked]="item.selected" />
                                  {{ item.name }}
                                </label>
                              </li>
                            }
                          </ul>
                        </nz-dropdown-menu>
                      </div>
                    </th>
                    <th>
                      <div class="table-title-align">
                        {{ weeklyScheduleMX.division }}
                        <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter5" nzTrigger="click" [nzClickHide]="false">
                          <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                        </a>
                        <nz-dropdown-menu #filter5="nzDropdownMenu" nzClickHide="false">
                          <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                            @for (item of division; track item) {
                              <li nz-menu-item>
                                <label>
                                  <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.division)"
                                    [checked]="item.selected" />
                                    {{ item.name }}
                                  </label>
                                </li>
                              }
                            </ul>
                          </nz-dropdown-menu>
                        </div>
                      </th>
                      <th>
                        <div class="table-title-align">{{ weeklyScheduleMX.unit }}
                          <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter6" nzTrigger="click" [nzClickHide]="false">
                            <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                          </a>
                          <nz-dropdown-menu #filter6="nzDropdownMenu" nzClickHide="false">
                            <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                              @for (item of unit; track item) {
                                <li nz-menu-item>
                                  <label>
                                    <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.unit)"
                                      [checked]="item.selected" />
                                      {{ item.name }}
                                    </label>
                                  </li>
                                }
                              </ul>
                            </nz-dropdown-menu>
                          </div>
                        </th>
                        <th>
                          <div class="table-title-align">{{ weeklyScheduleMX.crew }}
                            <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter7" nzTrigger="click" [nzClickHide]="false">
                              <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                            </a>
                            <nz-dropdown-menu #filter7="nzDropdownMenu" nzClickHide="false">
                              <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                                @for (item of crews; track item) {
                                  <li nz-menu-item>
                                    <label>
                                      <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.crew)"
                                        [checked]="item.selected" />
                                        {{ item.name }}
                                      </label>
                                    </li>
                                  }
                                </ul>
                              </nz-dropdown-menu>
                            </div>

                          </th>
                          <th>
                            <div class="table-title-align">{{ weeklyScheduleMX.basecraft }}
                              <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter8" nzTrigger="click" [nzClickHide]="false">
                                <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                              </a>
                              <nz-dropdown-menu #filter8="nzDropdownMenu" nzClickHide="false">
                                <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                                  @for (item of basecraft; track item) {
                                    <li nz-menu-item>
                                      <label>
                                        <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.basecraft)"
                                          [checked]="item.selected" />
                                          {{ item.name }}
                                        </label>
                                      </li>
                                    }
                                  </ul>
                                </nz-dropdown-menu>
                              </div>
                            </th>
                            <th>
                              <div class="table-title-align">{{ weeklyScheduleMX.location }}
                                <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter9" nzTrigger="click" [nzClickHide]="false">
                                  <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                                </a>
                                <nz-dropdown-menu #filter9="nzDropdownMenu" nzClickHide="false">
                                  <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                                    @for (item of location; track item) {
                                      <li nz-menu-item>
                                        <label>
                                          <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.location)"
                                            [checked]="item.selected" />
                                            {{ item.name }}
                                          </label>
                                        </li>
                                      }
                                    </ul>
                                  </nz-dropdown-menu>
                                </div>
                              </th>
                              <th>
                                <div class="table-title-align">{{ weeklyScheduleMX.taskTitle }}
                                  <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter10" nzTrigger="click" [nzClickHide]="false">
                                    <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                                  </a>
                                  <nz-dropdown-menu #filter10="nzDropdownMenu" nzClickHide="false">
                                    <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                                      @for (item of taskTitle; track item) {
                                        <li nz-menu-item>
                                          <label>
                                            <input type="checkbox" (change)="onFilterChange(item.name, weeklyScheduleMXFilters.taskTitle)"
                                              [checked]="item.selected" />
                                              {{ item.name }}
                                            </label>
                                          </li>
                                        }
                                      </ul>
                                    </nz-dropdown-menu>
                                  </div>
                                </th>
                                <th>{{ weeklyScheduleMX.longDescription }}</th>
                                <th nz-tooltip nzTooltipTitle="Finish By Date">
                                  {{ weeklyScheduleMX.fbd }}
                                </th>
                                <th>{{ weeklyScheduleMX.d1 }}</th>
                                <th>{{ weeklyScheduleMX.d2 }}</th>
                                <th>{{ weeklyScheduleMX.d3 }}</th>
                                <th>{{ weeklyScheduleMX.d4 }}</th>
                                <th>{{ weeklyScheduleMX.d5 }}</th>
                                <th>{{ weeklyScheduleMX.d6 }}</th>
                                <th>{{ weeklyScheduleMX.d7 }}</th>
                                <th>
                                  <div class="table-title-align">
                                    {{ weeklyScheduleMX.workType }}
                                    <a class="pl-1" nz-dropdown [nzDropdownMenu]="filter11" nzTrigger="click" [nzClickHide]="false">
                                      <i nz-icon nzType="filter" class="w-20-px" nz-tooltip nzTooltipTitle="Filter"></i>
                                    </a>
                                    <nz-dropdown-menu #filter11="nzDropdownMenu" nzClickHide="false">
                                      <ul nz-menu class="dropdown-scroll overflow-auto pl-2 pr-2">
                                        @for (item of workTypes; track item) {
                                          <li nz-menu-item>
                                            <label>
                                              <input type="checkbox" (change)="onFilterChange(item.name,weeklyScheduleMXFilters.workType)"
                                                [checked]="item.selected" />
                                                {{ item.name }}
                                              </label>
                                            </li>
                                          }
                                        </ul>
                                      </nz-dropdown-menu>
                                    </div>
                                  </th>
                                  <th nz-tooltip nzTooltipTitle="History Brief Indicator">
                                    {{ weeklyScheduleMX.hist }}
                                  </th>
                                  <th nz-tooltip nzTooltipTitle="Hrs Charged To Task This Week">
                                    {{ weeklyScheduleMX.chrg }}
                                  </th>
                                  <th nz-tooltip nzTooltipTitle="Total Task Estimate Hours...">
                                    {{ weeklyScheduleMX.sch }}
                                  </th>
                                  <th nz-tooltip nzTooltipTitle="Total Task Actual Hours...">
                                    {{ weeklyScheduleMX.plan }}
                                  </th>
                                  <th>{{ weeklyScheduleMX.mphc }}</th>
                                  <th>{{ weeklyScheduleMX.attachedDoc }}</th>
                                  <th>{{ weeklyScheduleMX.delayCode }}</th>
                                  <th>{{ weeklyScheduleMX.delayDesciption }}</th>
                                  <th>{{ weeklyScheduleMX.criticality }}</th>
                                  <th>{{ weeklyScheduleMX.histFlg }}</th>
                                  <th>{{ weeklyScheduleMX.miScope }}</th>
                                </tr>
                                @if (showLoader) {
                                  <div class="item-center mt-5">
                                    <mat-progress-spinner color="primary" mode="indeterminate" diameter="50"></mat-progress-spinner>
                                  </div>
                                }

                                @if (!showLoader && weeklySchedule.length == 0) {
                                  <div class="item-center mt-5">
                                    <h5>{{ weeklyScheduleMX.noDataFound }}</h5>
                                  </div>
                                }
                                @for (item of weeklySchedule; track item) {
                                  <tr>
                                    <td>{{ item.taskPriority }}</td>
                                    <td class="text-nowrap">
                                      <a nz-tooltip nzTooltipTitle="Click To See Detail..." (click)="generateLinkUsingWonum(item.wonum)">{{
                                      item.wonum }}</a>
                                    </td>
                                    <td>{{ item.taskType }}</td>
                                    <td>
                                      <span class="color-brown">{{ item.sme }}</span>
                                    </td>
                                    <td>{{ item.taskStatus }}</td>
                                    <td>{{ item.division }}</td>
                                    <td>{{ item.unit }}</td>
                                    <td>{{ item.crew }}</td>
                                    <td>{{ item.baseCraft }}</td>
                                    <td>{{ item.location }}</td>
                                    <td class="text-nowrap">
                                      <span nz-tooltip nzTooltipTitle="{{ item.taskTitle }}">{{
                                        shortenText(item.taskTitle)
                                      }}</span>
                                    </td>
                                    <td class="text-nowrap">
                                      <span nz-tooltip nzTooltipTitle="{{ item.taskLongDescription }}">{{
                                        shortenText(item.taskLongDescription)
                                      }}</span>
                                    </td>
                                    <td>{{ formatDates(item.fbd) }}</td>
                                    <td>
                                      <a (click)="openDateSelection(item.wonum)">{{ item.d1 }}</a>
                                    </td>
                                    <td>
                                      <a (click)="openDateSelection(item.wonum)">{{ item.d2 }}</a>
                                    </td>
                                    <td>
                                      <a (click)="openDateSelection(item.wonum)">{{ item.d3 }}</a>
                                    </td>
                                    <td>
                                      <a (click)="openDateSelection(item.wonum)">{{ item.d4 }}</a>
                                    </td>
                                    <td>
                                      <a (click)="openDateSelection(item.wonum)">{{ item.d5 }}</a>
                                    </td>
                                    <td>
                                      <a (click)="openDateSelection(item.wonum)">{{ item.d6 }}</a>
                                    </td>
                                    <td>
                                      <a (click)="openDateSelection(item.wonum)">{{ item.d7 }}</a>
                                    </td>
                                    <td class="text-nowrap">
                                      <span class="color-brown">{{ item.workTypeLong }}</span>
                                    </td>
                                    <td>
                                      <span class="color-brown">{{ item.hist }}</span>
                                    </td>
                                    <td>{{ item.totalHours | round }}</td>
                                    <td>{{ item.scheduledHours | round }}</td>
                                    <td>{{ item.hoursActual | round }}</td>
                                    <td>{{ item.mpQty }}</td>
                                    <td>
                                      @if (item.docUrl) {
                                        <a [href]="item.docUrl" target="_blank" nz-tooltip nzTooltipTitle="{{ item.docName }}">{{ shortenText(item.docName) }}</a>
                                      } @else {
                                        <span nz-tooltip nzTooltipTitle="{{ item.docName }}">{{ shortenText(item.docName) }}</span>
                                      }
                                    </td>
                                    <td>
                                      {{
                                      item.jobDelayCode === null || item.jobDelayCode === ""
                                      ? ""
                                      : "Y"
                                      }}
                                    </td>
                                    <td>
                                      <span nz-tooltip nzTooltipTitle="{{ item.delayDesc }}">{{
                                        shortenText(item.delayDesc)
                                      }}</span>
                                    </td>
                                    <td>{{ item.criticality }}</td>
                                    <td>{{ item.hist === "+" ? "Y" : "" }}</td>
                                    <td>{{ item.miScope }}</td>
                                  </tr>
                                }
                              </table>
                            </nz-row>

                            <!-- Footer -->
                            <nz-row class="p-t-b-12 p-l-r-12 bgColor">
                              <nz-col nzSpan="9" class="display-flex">
                                <table>
                                  <tr>
                                    <th>
                                      <span class="text-red">{{ weeklyScheduleMX.omitInd }}</span>
                                    </th>
                                    <th>{{ weeklyScheduleMX.openTotal }}</th>
                                    <th>{{ weeklyScheduleMX.doneTotal }}</th>
                                    <th>{{ weeklyScheduleMX.total }}</th>
                                  </tr>
                                  <tr>
                                    <th>Break-In:</th>
                                    <td>{{ weeklyScheduleTotal?.biOpen }}</td>
                                    <td>{{ weeklyScheduleTotal?.biDone }}</td>
                                    <td>{{ weeklyScheduleTotal?.biTotal }}</td>
                                  </tr>
                                  <tr>
                                    <th>PM:</th>
                                    <td>{{ weeklyScheduleTotal?.pmOpen }}</td>
                                    <td>{{ weeklyScheduleTotal?.pmDone }}</td>
                                    <td>{{ weeklyScheduleTotal?.pmTotal }}</td>
                                  </tr>
                                  <tr>
                                    <th>Safety:</th>
                                    <td>{{ weeklyScheduleTotal?.sfOpen }}</td>
                                    <td>{{ weeklyScheduleTotal?.sfDone }}</td>
                                    <td>{{ weeklyScheduleTotal?.sfTotal }}</td>
                                  </tr>
                                  <tr>
                                    <th>ALL:</th>
                                    <td>{{ weeklyScheduleTotal?.allOpen }}</td>
                                    <td>{{ weeklyScheduleTotal?.allDone }}</td>
                                    <td>{{ weeklyScheduleTotal?.allTotal }}</td>
                                  </tr>
                                </table>
                              </nz-col>

                              <nz-col nzSpan="6"> </nz-col>

                              <nz-col nzSpan="9" class="display-flex">
                                <table>
                                  <tr>
                                    <th>{{ weeklyScheduleMX.totalScheduled }}</th>
                                    <td>$ {{ totalNScheduled }}</td>

                                    <th>{{ weeklyScheduleMX.totalActual }}</th>
                                    <td>{{ totalNActual }}</td>
                                  </tr>

                                  <tr>
                                    <th>{{ weeklyScheduleMX.totalHrsSched }}</th>
                                    <td>{{ totalHrsScheduled }}</td>

                                    <th>{{ weeklyScheduleMX.totalEqMp }}</th>
                                    <td>{{ totalEqMp }}</td>
                                  </tr>

                                  <tr>
                                    <th>{{ weeklyScheduleMX.totalHrsCharged }}</th>
                                    <td>{{ totalHrsCharged }}</td>

                                    <th>{{ weeklyScheduleMX.chargeSched }}</th>
                                    <td>{{ chargeSched }}</td>
                                  </tr>

                                  <tr>
                                    <th>{{ weeklyScheduleMX.totalHrsPlanned }}</th>
                                    <td>{{ totalHrsPlanned }}</td>

                                    <th>{{ weeklyScheduleMX.schedPlan }}</th>
                                    <td>{{ schedplan }} %</td>
                                  </tr>
                                </table>
                              </nz-col>
                            </nz-row>
                          </nz-col>
                        </nz-row>
                      </div>
